import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { DrawerLayoutWrapper } from 'common';
import ProgressBar from 'feature/dispatching/components/ProgressBar';
import LocationsForm from '../components/LocationsForm';
import { useViewTrailerSummaryByLocationQuery } from '../../trailerStatusEndpoints';

const lens = R.lensProp('locations');

const Locations = ({ onClose, next, prev, trailerState, setTrailerState }) => {
  const { locations } = trailerState;

  const { data = [], isLoading } = useViewTrailerSummaryByLocationQuery();

  // prettier-ignore
  const isInvalid = R.o(
    R.gt(1), 
    R.path(['locations', 'length'])
  )(trailerState);

  const handleAdd = locationId => {
    const over = R.append(locationId);
    setTrailerState(R.over(lens, over));
  };

  const handleRemove = locationId => {
    const over = R.reject(R.equals(locationId));
    setTrailerState(R.over(lens, over));
  };

  const buttons = (
    <Box sx={{ display: 'flex', justifyContent: 'space-around', width: 1 }}>
      <Button onClick={prev} sx={{ width: 150 }} variant="outlined">
        Back
      </Button>
      <Button disabled={isInvalid} onClick={next} sx={{ width: 150 }}>
        Continue
      </Button>
    </Box>
  );

  return (
    <DrawerLayoutWrapper
      buttons={buttons}
      headerButtonText="CLOSE"
      isLoading={isLoading}
      onHeaderButtonClick={onClose}
      title="New Trailer"
    >
      <ProgressBar
        label="Locations (4 of 5)"
        sx={{
          '&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar': {
            borderRadius: '10px',
          },
        }}
        value={80}
      />
      <Stack sx={{ mt: 3, width: 390 }}>
        <LocationsForm
          locations={locations}
          onAdd={handleAdd}
          onRemove={handleRemove}
          selectableLocations={data.map(R.pick(['locationId', 'name', 'address']))}
          title="Selectable Locations"
        />
      </Stack>
    </DrawerLayoutWrapper>
  );
};

Locations.propTypes = {
  next: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
  setTrailerState: PropTypes.func.isRequired,
  trailerState: PropTypes.shape({
    locations: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default Locations;
